import { SERVICES_ACCESS } from "@/modules/Services/constants/ServicesConstants";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import {
  GENERAL_CONSTANTS,
  NAME_FINDERS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";

import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  FILTER_SEARCH_NOTIFICATION_PROFILE,
  PROFILE_CONSTANTS,
  NOTIFICATION_CONSTANTS,
  NOTIFICATION_ID
} from "../../constants/ProfileConstants";
import FilterSearch from "../FilterSearch/FilterSearch.vue";
import Vuetify from "vuetify";
import SearchOneFilter from "../../../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import TooltipToggleButton from "../../../../shared/components/TooltipToggleButton/TooltipToggleButton.vue";
import {
  ItemFilterObj,
  QueryFilter
} from "@/shared/components/GenericSearchBar/model/FilterOneItem";

import { GO_TO_TOP } from "@/modules/Home/constants/HomeConstants";

import { NotificationService } from "@/modules/Notification/services/NotificationService";
import { NotificationSchudule } from "@/modules/Notification/models/NotificationSchudule";
import { QuerySearchNotification } from "@/modules/Notification/models/QuerySearchNotification";
import NotificationData from "./NotificationDetail/NotificationData.vue";

Vue.use(Vuetify);
@Component({
  name: "ListNotifications",
  components: {
    EmptyState,
    ModalTemplate,
    FilterSearch,
    SearchOneFilter,
    TooltipToggleButton,
    NotificationData
  },
  computed: {
    ...mapGetters({
      userActive: "getUserState"
    })
  }
})
export default class ListServices extends Vue {
  @Prop() public userId!: string;
  @Prop() public isInPanel!: boolean;
  @Prop() private serviceId?: string;
  @Prop() private refresh?: boolean;
  @Inject() notificationService!: NotificationService;

  dataToLateralMenu!: MenuDataStructure;
  userActive!: boolean;

  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  EMPTY_TITLE = PROFILE_CONSTANTS.EMPTY_TITLE_NOTIFICATION;
  EMPTY_TEXT = PROFILE_CONSTANTS.EMPTY_TEXT_NOTIFICATION;
  EMPTY_TEXT_FILTER = PROFILE_CONSTANTS.EMPTY_TEXT_NOTIFICATION_FILTER;
  GO_TO_TOP_BTN = GO_TO_TOP;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  modalConfirmationText = "";
  modalConfirmationTitle = "";
  dialogConfirmation = false;

  historyNotificationList: NotificationSchudule[] = [];
  notificationList: NotificationSchudule[] = [];
  scheduleNotification: NotificationSchudule[] = [];
  notificationListAll: NotificationSchudule[] = [];
  lastRefNotification = "";
  lastRefSchedule = "";
  lastRefHistory = "";
  querySearchNotification: QuerySearchNotification = {};
  loadingNotification = false;
  loading = true;
  empty = false;
  dataToMainView = {};
  showGoTopBtn = false;
  NOTIFICATION_ID = NOTIFICATION_ID;
  staticChannels = NOTIFICATION_CONSTANTS.STATIC_CHANNELS;
  staticStates = NOTIFICATION_CONSTANTS.STATIC_STATES;
  LABELS_HTML = NOTIFICATION_CONSTANTS;
  filterRef = "";

  generalDataService: ServiceHeaderData[] = [];
  generalData: NotificationSchudule[] = [];
  searchResultData: NotificationSchudule[] = [];
  itemUpdate: NotificationSchudule = {};
  searchQuery = "";
  showItem: number[] = [];

  NOTIFICATION_CONTEXTUAL_KEY = NAME_FINDERS.NOTIFICATION_CONTEXTUAL;
  itemFilter = {
    ...FILTER_SEARCH_NOTIFICATION_PROFILE
  };

  filtern: QueryFilter = {};

  basicBtnClassRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  BTN_HINT = NOTIFICATION_CONSTANTS.BTN_HINT;
  toggleHint = NOTIFICATION_CONSTANTS.SHOW_DETAILS;
  state = false;
  filterNotificationModel = "1";
  changeNotificationType = false;

  toggleSwitch(index: number) {
    this.generalData[index].open = !this.generalData[index].open;
  }

  selectItem(item: ItemFilterObj) {
    if (!item || !item.name || !item.type) {
      this.filtern = {};
      return;
    }
    this.filtern = { [item.type]: item.name };
  }

  filterOut(filter: QueryFilter) {
    this.filtern = filter;
  }

  get listState(): ItemFilterObj[] {
    return (
      this.staticStates?.map(item => ({
        id: item,
        name: item
      })) ?? []
    );
  }

  get listChannels(): ItemFilterObj[] {
    return (
      this.staticChannels?.map(item => ({
        id: item,
        name: item
      })) ?? []
    );
  }

  get ListActual() {
    const filterKeys = Object.keys(this.filtern);

    this.generalData = this.generalData.map(item => {
      return {
        ...item,
        open: false
      };
    });

    if (filterKeys.length == 0) {
      return this.generalData;
    }
    const filterText = this.filtern[filterKeys[0]]?.toUpperCase();
    if (!filterText) {
      return this.generalData;
    }
    const filterKey = filterKeys[0];
    this.filterRef = filterKey;

    return (
      this.generalData?.filter(item => {
        if (filterKey == NOTIFICATION_CONSTANTS.STATIC_FILTERS.TITLE) {
          if (item.message?.title) {
            return item.message?.title?.toUpperCase().includes(filterText);
          }
          return item.name?.toUpperCase().includes(filterText);
        }
        if (filterKey == NOTIFICATION_CONSTANTS.STATIC_FILTERS.CHANNELS) {
          const filterTextLowerCase = filterText.toLowerCase();
          return item.channels && item.channels.includes(filterTextLowerCase);
        }
        if (filterKey == NOTIFICATION_CONSTANTS.STATIC_FILTERS.STATES) {
          return item.state?.toUpperCase().includes(filterText);
        }
      }) ?? []
    );
  }

  async mounted() {
    await this.ejectNotificationAll();
  }

  handleEnterPressed(value: string) {
    this.searchQuery = value;
  }

  @Watch("searchQuery")
  async refreshSearch() {
    await this.ejectNotificationAll();
    if (this.searchQuery != null && this.searchQuery != "") {
      await this.ejectNotificationAll();
    }
    this.loadingNotification = false;
  }

  showCancelNotificationModal(item: NotificationSchudule) {
    this.modalConfirmationText = NOTIFICATION_CONSTANTS.MESSAGE_MODAL.BODY;
    this.modalConfirmationTitle = NOTIFICATION_CONSTANTS.MESSAGE_MODAL.TITLE;
    this.itemUpdate = item;
    this.dialogConfirmation = true;
  }

  toggleDetailNotification(flag: number) {
    if (this.showItem.includes(flag)) {
      this.showItem.splice(this.showItem.indexOf(flag), 1);
    } else {
      this.showItem.push(flag);
    }
  }

  evalTimestamp(date: number) {
    const dateNow = new Date().getTime();
    const dateTimestamp = new Date(date).getTime();
    if (dateTimestamp > dateNow) {
      return true;
    } else {
      return false;
    }
  }

  getFormatDateHour(date: number) {
    const dateHour = new Date(date).toLocaleString(
      NOTIFICATION_CONSTANTS.LOCAL_HOUR
    );
    return `${dateHour}`;
  }

  async getHistoryNotifications() {
    this.loadingNotification = true;
    try {
      if (this.searchQuery) {
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.TITLE
          ? (this.querySearchNotification.name = this.searchQuery)
          : null;
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.CHANNELS
          ? (this.querySearchNotification.channels = this.searchQuery)
          : null;
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.STATES
          ? (this.querySearchNotification.state = this.searchQuery)
          : null;
      }

      if (this.lastRefHistory && !this.changeNotificationType) {
        this.querySearchNotification.docref = this.lastRefHistory;
      }
      const response = await this.notificationService.getNotificationsByUserProfile(
        this.userId,
        this.querySearchNotification
      );

      if (response.code === Http.Found && response.data) {
        const list: {
          notifications: NotificationSchudule[];
          docref: string;
        } = response.data;
        this.historyNotificationList = list.notifications;
        this.generalData = [
          ...this.generalData,
          ...this.historyNotificationList
        ];

        this.generalData = this.generalData.filter(
          (item, index, self) =>
            index === self.findIndex(t => t._key === item._key)
        );
        this.lastRefHistory = list.docref;
        this.loadingNotification = false;
        this.loading = false;
        this.changeNotificationType = false;
      }
      this.loadingNotification = false;
      this.loading = false;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      this.loadingNotification = false;
      Snackbar.popError(errorMessage);
    }
  }

  async getNotificationSchedule() {
    try {
      if (this.searchQuery) {
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.TITLE
          ? (this.querySearchNotification.name = this.searchQuery)
          : null;
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.CHANNELS
          ? (this.querySearchNotification.channels = this.searchQuery)
          : null;
        this.filterRef == NOTIFICATION_CONSTANTS.STATIC_FILTERS.STATES
          ? (this.querySearchNotification.state = this.searchQuery)
          : null;
      }
      if (this.lastRefSchedule && !this.changeNotificationType) {
        this.querySearchNotification.docref = this.lastRefSchedule;
      }
      const response = await this.notificationService.getScheduledActions(
        this.userId,
        this.querySearchNotification
      );

      if (response.code === Http.Found && response.data) {
        const list: {
          notifications: NotificationSchudule[];
          docref: string;
        } = response.data;
        this.scheduleNotification = list.notifications;

        this.generalData = [...this.generalData, ...this.scheduleNotification];

        this.generalData = this.generalData.filter(
          (item, index, self) =>
            index === self.findIndex(t => t._key === item._key)
        );

        this.lastRefSchedule = list.docref;
        this.loadingNotification = false;
        this.loading = false;
        this.changeNotificationType = false;
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  async ejectNotificationAll() {
    this.itemFilter.listItemFilterObj!.channels = this.listChannels;
    this.itemFilter.listItemFilterObj!.state = this.listState;
    if (Number(this.filterNotificationModel)) {
      await this.getHistoryNotifications();
    } else {
      await this.getNotificationSchedule();
    }
    this.loading = false;
  }

  async handleModalAccept() {
    this.updateStateNotification(
      this.itemUpdate,
      NOTIFICATION_CONSTANTS.STATIC_CANCELATION,
      this.itemUpdate?.flagType!
    );
    this.dialogConfirmation = false;
    Snackbar.popSuccess(NOTIFICATION_CONSTANTS.MESSAGES_RESPONSE.CANCEL);
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
  }
  @Watch("filterRef")
  async refreshFilter() {
    await this.ejectNotificationAll();
  }

  @Watch("filterNotificationModel")
  async refreshFilterTypeNotification() {
    this.generalData = [];
    this.querySearchNotification = {};
    this.loading = true;
    this.lastRefHistory = "";
    this.lastRefNotification = "";
    this.lastRefSchedule = "";
    this.changeNotificationType = true;
    await this.ejectNotificationAll();
  }

  async refreshListNotification() {
    this.lastRefHistory = "";
    this.lastRefNotification = "";
    this.lastRefSchedule = "";
    await this.ejectNotificationAll();
  }

  async updateStateNotification(
    item: NotificationSchudule,
    state: string,
    flagType: string
  ) {
    try {
      if (flagType === NOTIFICATION_CONSTANTS.STATIC_FLAGTYPES.PROGRAMADA) {
        const response = await this.notificationService.cancelScheduledNotification(
          item._key!,
          this.userId
        );
        if (response.code === Http.Found && response.data) {
          this.generalData = this.generalData.map(
            (itemFilter: NotificationSchudule) =>
              itemFilter._key === item._key
                ? { ...itemFilter, state: state }
                : itemFilter
          );
          await this.getHistoryNotifications();
        }
      }

      if (flagType === NOTIFICATION_CONSTANTS.STATIC_FLAGTYPES.REGLA) {
        const response = await this.notificationService.cancelScheduledAction(
          item._key!,
          this.userId
        );

        if (response.code !== Http.Found) throw Error;

        if (response.data.newDateToExecute) {
          this.generalData = this.generalData.map(
            (itemFilter: NotificationSchudule) =>
              itemFilter._key === item._key
                ? {
                    ...itemFilter,
                    dateToExecute: response.data.newDateToExecute
                  }
                : itemFilter
          );
          await this.getNotificationSchedule();
          return;
        }

        this.generalData = this.generalData.map(
          (itemFilter: NotificationSchudule) =>
            itemFilter._key === item._key
              ? { ...itemFilter, dateToExecute: response.data.state }
              : itemFilter
        );

        await this.getNotificationSchedule();
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  async onScroll(event: Event) {
    const target = event.target as HTMLElement;

    this.showGoTopBtn = target.scrollTop >= 100;
    if (target.scrollTop + target.clientHeight + 5 >= target.scrollHeight) {
      target.scrollTop -= 3;
      await this.ejectNotificationAll();
      target.scrollTop -= 2;
    }
  }

  goToTop() {
    const target = document.getElementById(this.NOTIFICATION_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }
}
